import React from 'react';
import { MessageInput, MessageList, Thread, useChannelStateContext, useChatContext, Window } from 'stream-chat-react';
import { TeamChannelHeader } from './TeamChannelHeader';
import { useStreamChatContext } from '~/react_context/StreamChatContext';

const actions = ['delete', 'markUnread', 'react', 'reply'];

const ChannelInner = () => {
	const { client } = useChatContext();
	const { channel, members } = useChannelStateContext();
	const { onChannelListChange } = useStreamChatContext();
	const currentUserId = client.userID!;

	if (!members) {
		return null;
	}

	const onClickJoinChannel = async () => {
		await channel.addMembers([currentUserId]);
		onChannelListChange();
	};

	return (
		<>
			<Window>
				<TeamChannelHeader />
				<MessageList messageActions={actions} />
				{members[currentUserId] ? (
					<MessageInput minRows={1} maxRows={4} />
				) : (
					<button
						className="rounded-md border border-transparent bg-primary px-4 py-2 text-base font-medium text-white shadow-xs hover:bg-primary-dark focus:outline-hidden focus:ring-2 focus:bg-primary focus:ring-offset-2 sm:col-start-2 sm:text-lg disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-600"
						onClick={onClickJoinChannel}
						type="button"
					>
						Join #{channel.data?.name}
					</button>
				)}
			</Window>
			<Thread additionalMessageInputProps={{ maxRows: 4, minRows: 1 }} />
		</>
	);
};

export default ChannelInner;
